import React from 'react';
import { NewsDetailsProvider } from './context/news-details-context';
import { NewDetailsPage } from './newDetails.page';

export const NewsDetailsFactory: React.FC = () => {
  return (
    <NewsDetailsProvider>
      <NewDetailsPage />
    </NewsDetailsProvider>
  );
};